<template>
  <div class="main_body_newStore" >
    <div class="main_head_newStore">
      <img src="../../../../assets/store/store_red.png" width="95%"
           style="position: absolute;margin: auto;left: 0;right: 0;top: 4.2rem">
      <div style="margin-top: 13.1rem;">
        <img src="../../../../assets/store/go_market.png" @click="goMarket()" width="75%"
             style="position: absolute;margin: auto;left: 0;right: 0;">
        <img src="../../../../assets/store/go_cs.png" @click="goAward()" width="75%"
             style="position: absolute;margin: auto;left: 0;right: 0;margin-top: 2rem">
        <span   style="position: absolute;margin: auto;left: 0;right: 0;z-index: 2;top: 18rem;text-align: center;opacity: 0.8;color: #FFFFFF;font-size: 0.4rem">本活动最终解释权归官方所有</span>

      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      content:"",//内容
    }
  },

  // 方法
  methods: {
    // 跳转客服
    goAward() {

      window.android.getAward();
    },
     // 跳转应用市场
    goMarket() {
      window.android.goMarket();
    },

  }
}
</script>

<style>
.main_body_newStore {
  display: flex;
  flex-flow: column nowrap;
  width: 100%;
  height: 0;
  padding-bottom: 210%;
  background: -webkit-linear-gradient(top,rgba(130, 20, 192, 1), rgba(31, 10, 118, 1)) no-repeat;
  background-size: 100%;
}

.main_head_newStore {
  width: 100%;
  height: 0;
  padding-bottom: 59%;
  background-image: url('../../../../assets/store/store_head.png');
  background-size: 100%;
}

</style>



// WEBPACK FOOTER //
// src/view/pomelo/app/newStore/index.vue